import React from 'react';

const Card = ({ index, card, handleCardChange, removeCardField, lang }) => {
    return (
        <div className="relative bg-black bg-opacity-20 p-4 space-y-3 border border-gray-600">
            <div>
                <label className="block text-white text-sm font-avenir">
                    {lang === 'de' ? 'Ladekartennummer *' : 'Charging Card Number *'}
                </label>
                <input
                    type="text"
                    value={card.tagId}
                    onChange={(e) => handleCardChange(index, 'tagId', e.target.value)}
                    className="block w-full border border-gray-300 p-2 text-gray-900 font-avenir hover:border-primary focus:border-primary focus:ring-transparent custom-transition"
                    placeholder={lang === 'de' ? 'z. B. 12345678' : 'e.g., 12345678'}
                    required
                />
            </div>
            <div>
                <label className="block text-white text-sm font-avenir">
                    {lang === 'de' ? 'Referenz (z. B. Kennzeichen)' : 'Reference (e.g., License Plate)'}
                </label>
                <input
                    type="text"
                    value={card.reference}
                    onChange={(e) => handleCardChange(index, 'reference', e.target.value)}
                    className="block w-full border border-gray-300 p-2 text-gray-900 font-avenir hover:border-primary focus:border-primary focus:ring-transparent custom-transition"
                    placeholder={lang === 'de' ? 'z. B. AB CD 123' : 'e.g., AB CD 123'}
                />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                    <label className="block text-white text-sm font-avenir">
                        {lang === 'de' ? 'Ladekarte gültig ab (sofern nicht sofort gültig)' : 'Valid From (optional)'}
                    </label>
                    <input
                        type="date"
                        value={card.validFrom}
                        onChange={(e) => handleCardChange(index, 'validFrom', e.target.value)}
                        className="block w-full border border-gray-300 p-2 text-gray-900 font-avenir hover:border-primary focus:border-primary focus:ring-transparent custom-transition"
                    />
                </div>
                <div>
                    <label className="block text-white text-sm font-avenir">
                        {lang === 'de' ? 'Ladekarte gültig bis (sofern relevant)' : 'Valid To (optional)'}
                    </label>
                    <input
                        type="date"
                        value={card.validTo}
                        onChange={(e) => handleCardChange(index, 'validTo', e.target.value)}
                        className="block w-full border border-gray-300 p-2 text-gray-900 font-avenir hover:border-primary focus:border-primary focus:ring-transparent custom-transition"
                    />
                </div>
            </div>
            {removeCardField && (
                <div className="flex justify-end">
                    <button
                        type="button"
                        onClick={() => removeCardField(index)}
                        className="text-red-500 hover:text-red-700 font-avenir"
                    >
                        {lang === 'de' ? 'Entfernen' : 'Remove'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default Card;
